import { IconMinus16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { ControlButton } from '../../../../../common/components/ControlButton';

export interface IZoomOutButtonProps {
  onZoomOut(): void;
  onClick(): void;
}

export const ZoomOutButton: React.FC<IZoomOutButtonProps> = props => {
  const { onZoomOut, onClick } = props;

  const handleZoomOutClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();
      onClick();
      onZoomOut();
    },
    [onZoomOut, onClick],
  );

  return (
    <ControlButton className={styles['button']} onClick={handleZoomOutClick} size="M">
      <IconMinus16 color="icon-primary-default" />
    </ControlButton>
  );
};
